import React from 'react';
import Button from '@jbhi-fi/lanyard-ui/components/Button';
import { bannerVariants, buttonVariants } from './ActionButton.css';
import { CartActionState } from '../CartProvider/types';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
type ButtonProps = Parameters<typeof Button>[0];

export type ActionButtonProps = {
  label: string;
  type?: ButtonProps['type'];
  isLoading?: boolean;
  icon?: HTMLElement | React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  size?: ButtonProps['size'];
  state?: CartActionState;
  showActionFinishedState?: boolean;
  actionFinishedClass?: string;
  actionFinishedLabel?: string;
  actionFinishedIcon?: HTMLElement | React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  onClick: (e: any) => void;
  dataTestId?: string;
};

export const ActionButton = ({
  label,
  type = 'action',
  state,
  icon,
  size,
  isLoading,
  showActionFinishedState = true,
  actionFinishedClass,
  actionFinishedLabel,
  actionFinishedIcon,
  onClick,
  dataTestId,
}: ActionButtonProps) => {
  return (
    <Button
      onClick={onClick}
      type={type}
      label={label}
      iconPosition="left"
      icon={icon}
      classes={state === CartActionState.Complete ? buttonVariants.addedState : buttonVariants.primary}
      fullWidth
      size={size}
      loading={isLoading || state === CartActionState.Updating}
      data-testid={dataTestId}
    >
      {showActionFinishedState ? (
        <span
          className={
            state === CartActionState.Complete
              ? classNames([actionFinishedClass, bannerVariants.addedState])
              : bannerVariants.primary
          }
        >
          <>
            {actionFinishedIcon || icon}
            {actionFinishedLabel}
          </>
        </span>
      ) : null}
    </Button>
  );
};
